import withSort from 'elements/HOC/withSort'
import CustomSelect from 'elements/Select/CustomSelect'
import withData from 'elements/Select/withData'
import { compose } from 'recompose'
import { boolLabelItemLayout, defaultFormItemLayout, rules } from "../../../../modules/FormItems";
import { dateVal } from '../../../../modules/Utils'
import React from 'react'
import { Checkbox, Col, DatePicker, Form, InputNumber, Row, TimePicker } from 'antd'
import _, { get } from 'lodash'

const TypeSelect = compose(
  withData({
    data: [
      { value: 'Office', key: 'office' },
      { value: 'Over Time', key: 'over-time' },
      { value: 'Home', key: 'home' },
      { value: 'Site', key: 'site' },
      { value: 'Public Holiday', key: 'public-holiday' },
      { value: 'Travel Day', key: 'travel-day' },
      { value: 'Rostered Day', key: 'rostered-day' },
    ],
  }),
  withSort
)(CustomSelect)

function TimesheetLinesForm(props) {
  const { line } = props
  const { officeHours } = props.timesheet
  const { getFieldDecorator, getFieldValue, setFieldsValue } = props.form

  console.log(line)
  let officeStart = dateVal(line, 'officeStart', getFieldValue('officeStart'))
  let officeEnd = dateVal(line, 'officeEnd', getFieldValue('officeEnd'))

  const onChangeOffice = (value, type) => {
    officeStart = type === 'officeStart' ? value : getFieldValue('officeStart')
    officeEnd = type === 'officeEnd' ? value : getFieldValue('officeEnd')
    if (!_.isEmpty(officeStart) && !_.isEmpty(officeEnd)) {
      const officeRange = _.round(officeEnd.diff(officeStart, 'minutes') / 30) / 2
      const overtime = officeRange - officeHours
      setFieldsValue({
        office: officeRange >= officeHours ? officeHours : officeRange,
        'over-time': overtime > 0 ? overtime : 0,
      })
    }
  }

  const isAllDay = getFieldValue('isAllDay') || get(line, 'type')

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Day">
            {getFieldDecorator('day', {
              initialValue: dateVal(line, 'day'),
            })(<DatePicker style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item {...boolLabelItemLayout} label={'All Day'}>
            {getFieldDecorator('isAllDay', {
              initialValue: get(line, 'isAllDay'),
              valuePropName: 'checked',
            })(<Checkbox placeholder={'is All Day'} />)}
          </Form.Item>
        </Col>
      </Row>
      {isAllDay && (
        <Row>
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label="type">
              {getFieldDecorator('type', {
                initialValue: get(line, 'type') || 'office',
                rules: rules.select,
              })(<TypeSelect style={{ width: '100%' }} />)}
            </Form.Item>
          </Col>
        </Row>
      )}
      {!isAllDay && (
        <>
          <Row>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label="Office Start">
                {getFieldDecorator('officeStart', {
                  initialValue: dateVal(line, 'officeStart'),
                })(
                  <TimePicker
                    minuteStep={15}
                    format={'HH:mm'}
                    onChange={(value) => onChangeOffice(value, 'officeStart')}
                    style={{ width: '100%' }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label="Office End">
                {getFieldDecorator('officeEnd', {
                  initialValue: dateVal(line, 'officeEnd'),
                })(
                  <TimePicker
                    minuteStep={15}
                    format={'HH:mm'}
                    onChange={(value) => onChangeOffice(value, 'officeEnd')}
                    style={{ width: '100%' }}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label="Total Office Hours">
                <InputNumber
                  disabled={true}
                  style={{ width: '100%' }}
                  value={
                    !_.isEmpty(getFieldValue('officeStart')) &&
                    !_.isEmpty(getFieldValue('officeEnd')) &&
                    _.round(getFieldValue('officeEnd').diff(getFieldValue('officeStart'), 'minutes') / 30) / 2
                  }
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Office">
                {getFieldDecorator('office', {
                  initialValue: get(line, 'office'),
                })(<InputNumber style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Over time">
                {getFieldDecorator('over-time', {
                  initialValue: get(line, 'over-time'),
                })(<InputNumber style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Home">
                {getFieldDecorator('home', {
                  initialValue: get(line, 'home'),
                })(<InputNumber style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Site">
                {getFieldDecorator('site', {
                  initialValue: get(line, 'site'),
                })(<InputNumber style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Public Holiday">
                {getFieldDecorator('public-holiday', {
                  initialValue: get(line, 'public-holiday'),
                })(<InputNumber style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Travel day">
                {getFieldDecorator('travel-day', {
                  initialValue: get(line, 'travel-day'),
                })(<InputNumber style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label="Rostered Day">
                {getFieldDecorator('rostered-day', {
                  initialValue: get(line, 'rostered-day'),
                })(<InputNumber style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
    </Form>
  )
}

TimesheetLinesForm.propTypes = {}
TimesheetLinesForm.defaultProps = {}

export default Form.create()(TimesheetLinesForm)
